import { createSlice } from '@reduxjs/toolkit';
import { NotificationState } from '@interfaces/components/notification';
import { getNotificationUnconfirmedCountAsync } from '@redux/actions/apiActions/notificationApiAction';

const initialState: NotificationState = {
  list: [],
  unreadCount: 0,
  loading: false,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    resetNotification(state) {
      state.list = [];
      state.unreadCount = 0;
    },

    confirmAllNotifications(state) {
      state.list = state.list.map(item => ({
        ...item,
        isConfirmed: true,
      }));
      state.unreadCount = 0;
    },
  },

  extraReducers: builder => {
    builder.addCase(
      getNotificationUnconfirmedCountAsync.fulfilled,
      (state, action) => {
        state.unreadCount = action.payload.count;
      }
    );
  },
});

export const { resetNotification, confirmAllNotifications } =
  notificationSlice.actions;

export default notificationSlice.reducer;
